import React from 'react';
import { useSpring, animated } from '@react-spring/web';

const Grow = ({ isVisible, ...rest }: { isVisible?: boolean; children?: React.ReactNode }) => {
  const styles = useSpring({
    transform: isVisible ? 'scale(1)' : 'scale(0.8)',
    opacity: isVisible ? 1 : 0.9,
    duration: 100,
  });

  return <animated.div style={styles} {...rest} />;
};

export default Grow;
